import { render, staticRenderFns } from "./EnviarCorreo.vue?vue&type=template&id=10a8afa3"
import script from "./EnviarCorreo.vue?vue&type=script&lang=ts"
export * from "./EnviarCorreo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports